import React from 'react'
import { Redirect } from 'react-router-dom'

class ProtectedRoute extends React.Component {

    render() {
        const Component = this.props.component;
        let user = sessionStorage.getItem('user');
        var bol = false;
        if(user != null)
            bol = JSON.parse(user).token != ''?true:false;  
        const isAuthenticated = bol;
        return isAuthenticated ? (
            <Component />
        ) : (
            <Redirect to={{ pathname: '/login' }} />
        );
    }
}

export default ProtectedRoute;